import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component } from "react";
import img_2 from "../../images/RABBIT LIFE LOGO with insurance-02.png";
import img_logo from "../../images/rabbitlife-logo.png";
import HeaderLogin from "../Component/HeaderLogin";
import OTP from "./otp";
import Main from "./Main";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment, TextField } from "@mui/material";

class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      loading: false,
      error_flag: false,
      error_meg: "เกิดข้อผิดพลาด โปรดลองใหม่อีกครั้ง",
      showPassword: false,
      nationality: "thai",
      username: "",
    };
  }

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  prevStep = () => {
    this.props.prevStep();
  };

  componentDidMount() {
    console.log("componentDidMount");
  }

  componentDidUpdate() {
    console.log("componentDidUpdate");
  }

  componentWillUnmount() {
    console.log("componentWillUnmount");
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  submit = () => {
    // this.props.nextStep();
    //fetch("/api/form", { method: "POST", body: JSON.stringify(data) });
    let username = document.getElementById("username").value;
    let password = document.getElementById("password").value;
    let nationality = this.state.nationality;
    // var newPassword =  document.getElementById('password').value;
    // var confirm_password =   document.getElementById('confirm_password').value;
    // var minNumberofChars = 8;
    // var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
    // alert(newPassword);
    this.setState({ username: username });
    this.setState({ password: password, loading: true });
    this.setState({ nationality: nationality });
    // console.log("username: " + username);
    // console.log("password: " + password);

    fetch(process.env.REACT_APP_API_BASEURL + "/api/user/activate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
        dob: password,
        nationality: nationality
      }),
    })
      .then((res) => res.json())

      .then((res) => {
        // console.log("activate : ", res);
        if (res.success === true) {
          const { step } = this.state;
          this.setState({
            step: 2,
          });
          this.setState({ loading: false });
        } else {
          this.setState({
            loading: false,
            error_flag: true,
            error_meg: res.payload.error,
          });
          //   alert(res.payload.error);
        }
      })
      .catch(function (res) {
        // console.log(res);
      });
  };

  render() {
    const { step, loading } = this.state;
    const { username, nationality } = this.state;
    switch (step) {
      case 1:
        return (
          <div>
            {loading && (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loading}
              >
                <CircularProgress
                  sx={{
                    animationDuration: "550ms",
                  }}
                  color="inherit"
                />
              </Backdrop>
            )}
            <HeaderLogin />
            <section className="sec-form" id="">
              <div className="container-fluid">
                <div className="row">
                  {/* <!-- <div className="col-md-4 col-sm-4 col-xs-12"></div> --> */}
                  <div className="col-lg-4 col-md- col-xs-12 p-5 mx-auto">
                    <div className="logo text-center">
                      <img className="img-fluid" src={img_2} alt="" />
                      <h4>iService</h4>
                    </div>

                    <form className="login-form mt-5">
                      <div className="form-group">
                        <label
                          style={{ marginBottom: "20px" }}
                          for="username"
                          id="lbl_email"
                        >
                          ลงทะเบียนสมาชิกใหม่ / Sign up
                        </label>

                        <div
                          style={{
                            display: "flex",
                            gap: "30px",
                            marginBottom: "20px",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <input
                              type="radio"
                              name="nationality"
                              value="thai"
                              checked={this.state.nationality === "thai"}
                              onChange={(e) =>
                                this.setState({
                                  nationality: e.target.value,
                                  username: "",
                                })
                              }
                              style={{ accentColor: "#f2654e" }}
                            />
                            สัญชาติไทย
                          </label>
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <input
                              type="radio"
                              name="nationality"
                              value="foreign"
                              checked={this.state.nationality === "foreign"}
                              onChange={(e) => {
                                this.setState({
                                  nationality: e.target.value,
                                  username: "",
                                });
                              }}
                              style={{ accentColor: "#f2654e" }}
                            />
                            ต่างชาติ
                          </label>
                        </div>

                        <TextField
                          type="text"
                          className="form-control form-control-lg"
                          style={{ borderWidth: 1 }}
                          id="username"
                          placeholder={
                            this.state.nationality === "foreign"
                              ? "เลขที่หนังสือเดินทาง"
                              : "เลขประจำตัวประชาชน 13 หลัก"
                          }
                          value={this.state.username}
                          error={
                            (this.state.nationality === "foreign" &&
                              this.state.username.length > 12) ||
                            (this.state.nationality === "thai" &&
                              (this.state.username.length > 13 ||
                                (this.state.username.length > 0 &&
                                  this.state.username.length < 13)))
                          }
                          helperText={
                            this.state.nationality === "foreign" &&
                            this.state.username.length > 12 ? (
                              <span
                                style={{
                                  color: "red",
                                  fontFamily: "Prompt-Thin",
                                }}
                              >
                                ระบุข้อมูลเลขหนังสือเดินทางผิดรูปแบบ
                              </span>
                            ) : this.state.nationality === "thai" &&
                              this.state.username.length > 0 &&
                              this.state.username.length < 13 ? (
                              <span
                                style={{
                                  color: "red",
                                  fontFamily: "Prompt-Thin",
                                }}
                              >
                                ระบุข้อมูลไม่ครบ 13 หลัก
                              </span>
                            ) : (
                              ""
                            )
                          }
                          inputProps={{
                            maxLength:
                              this.state.nationality === "foreign" ? 12 : 13,
                          }}
                          onChange={(e) => {
                            const input = e.target.value;
                            const { nationality } = this.state;

                            let value =
                              nationality === "foreign"
                                ? input
                                : input.replace(/\D/g, ""); // ให้กรอกเฉพาะเลขถ้าเป็นคนไทย

                            this.setState({ username: value });
                          }}
                        />

                        <TextField
                          type="password"
                          className="form-control form-control-lg mt-3"
                          id="password"
                          style={{ borderWidth: 1, marginBottom: "15px" }}
                          placeholder={
                            this.state.nationality === "foreign"
                              ? "วัน เดือน ปีเกิด (ค.ศ.) (ex. 31011977)"
                              : "วัน เดือน ปีเกิด (พ.ศ.) (ex. 31012520)"
                          }
                          inputProps={{
                            maxLength: 8,
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                          }}
                          fullWidth
                        />

                        {this.state.error_flag && (
                          <p className="text-danger">{this.state.error_meg}</p>
                        )}

                        <small id="emailHelp" className="form-text text-muted">
                          หากท่านประสบปัญหาในการสมัครสมาชิก หรือต้องการเปลี่ยนเบอร์โทรศัพท์ สามารถติดต่อ 026483600
                          ในวันและเวลาทำการ 8:00 - 17:00 น. หรือ Facebook Rabbit
                          Life
                        </small>
                      </div>
                      <a
                        onClick={this.submit}
                        type="button"
                        className="btn btn-primary btn-block btn-lg btn mt-3 cust-btn"
                      >
                        ลงทะเบียน
                      </a>
                      <a
                        href="/"
                        type="button"
                        className="btn btn-back-regis btn-block btn-lg btn mt-3 cust-btn-back"
                      >
                        ย้อนกลับ
                      </a>
                    </form>
                    <br />
                  </div>
                </div>
              </div>
            </section>
          </div>
        );

      case 2:
        return (
          <OTP username={this.state.username} password={this.state.password} />
        );
      case 3:
        return <Main />;
    }
  }
}

export default Registration;
